// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pk-1";
export var messageSideRight = "_pk-2";
export var subscribeToBackInStockBubbleContainer = "_pk-0";